module.exports = __webpack_public_path__ + "img/full0-min.c7fdadb1.png";